import React, {useState} from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography, InputLabel, Autocomplete, TextField,CircularProgress } from "@mui/material"
import style from "./style";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";

import CustomInput from "../../../.././../components/CustomInput";


const NewSalesOrder = ({itemList, handleItemList, handleAdd, loading,}) => {
  const [checked, setChecked] = useState(false);
  // const [overwrite, setOverwrite] = useState(false);
  // const [append, setAppend] = useState(false);


  const [product, setProduct] = useState([{
    name: "",
    //  itemId: "", 
    productName: "", desc: "", unitCost: "",qty: "", amount: ""
  }]);
  const [totalAmount, setTotalAmount] = useState("0");
  const [salesOrder, setSalesOrder] = useState("0");
  const [expiryDate, setExpiryDate] = useState(dayjs());
  const [Opportunity, setOpportunity] = useState(dayjs());
  const [description, setDescription] = useState();
  const [subtotal, setsubTotal] = useState();
  const [tax, setTax] = useState();
  const [grandTotal, setGrandTotal] = useState();
  const [currency, setCurrency] = useState();
  const [exchangeRate, setExchangeRate] = useState();





  const handleAddField = () => {
    setProduct([...product, {
      name: "",
      //  itemId: "",
      productName: "", desc: "", unitCost: "",qty: "", amount: ""
    }]);

  };
  const handleDeleteField = (index) => {
    const updatedProductInformation = [...product];
    updatedProductInformation.splice(index, 1);
    setProduct(updatedProductInformation);

  };

  const handleProduct = (value, index, key,) => {
    const updatedProjectDetails = [...product];
    if (key === "quantity" || key === "price") {
      const qty = key === "quantity" ? Number(value) : Number(updatedProjectDetails[index].quantity);
      const unitCost = key === "price" ? Number(value) : Number(updatedProjectDetails[index].price);
      updatedProjectDetails[index]["amount"] = (qty * unitCost);
      calculateTotalAmount();
    }
    if (key === "quantity") {
      updatedProjectDetails[index][key] = Number(value);
    }
    else if (key === "price") {
      updatedProjectDetails[index][key] = Number(value);
    } else {
      updatedProjectDetails[index][key] = value;
    }


    setProduct(updatedProjectDetails);
  }
  const calculateTotalAmount = () => {
    let total = 0;
    product.forEach(item => {
      total += Number(item.amount);
    });
    return setTotalAmount(total);
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    handleAdd(salesOrder, expiryDate, Opportunity, description, product, subtotal, grandTotal, currency, exchangeRate, tax,  totalAmount)

  }

  const handleChanges = (event) => {
    setChecked(event.target.checked);
  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#28AA4A",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
            theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
    
  }));
  
  return (
    <>


      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>New Sales Orders</Typography>
        </Box>
      </Box>

      <Box sx={style.itemSection}>
        <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
        <Typography sx={style.gridText}>Sales Order Information</Typography>
      </Box>

      <form onSubmit={e => handleSubmit(e)}>

        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Sales Order</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="order"
                  error={""}
                  name="salesOrder"
                  value={salesOrder}
                  onChange={(e, val) => setSalesOrder(val)}
                  autoComplete="order"
                />

              </Box>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>Expiry Date</InputLabel>
                  <DatePicker sx={style.dateInput} value={expiryDate} onChange={(value) => setExpiryDate(value)}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }} />
                </LocalizationProvider>

              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Opportunity</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="opportunity"
                  error={""}
                  name="opportunity"
                  value={Opportunity}
                  onChange={(e, val) => setOpportunity(val)}
                  autoComplete="order"
                />
              </Box>
            </Box>
            <Box sx={style.syncSection}>
              <Typography sx={style.syncHeading}>Sync Type</Typography>
              <Box sx={style.syncGrid}>
                <Box>                
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch checked={checked} onChange={handleChanges} />
                  </Stack>
                </Box>
                <Box sx={{ml:4}}><Typography sx={style.descText}>Do not sync with Opportunity Products</Typography></Box>
              </Box>
              <Box sx={style.syncGrid}>
                <Box>                
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch checked={checked} onChange={handleChanges} />
                  </Stack>
                </Box>
                <Box sx={{ml:4}}><Typography sx={style.descText}>Sync and overwrite Opportunity Products </Typography></Box>
              </Box>
              <Box sx={style.syncGrid}>
                <Box>                
                  <Stack direction="row" spacing={1} alignItems="center">
                    <AntSwitch checked={checked} onChange={handleChanges} />
                  </Stack>
                </Box>
                <Box sx={{ml:4}}><Typography sx={style.descText}>Sync and Append to Opportunity Products  </Typography></Box>
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBoxDes}>
                
                <Typography sx={style.inputText}>Description</Typography>
                <TextField
                  sx={{mt:1, borderRadius: "10px"}}
                  variant="outlined"
                  required
                  fullWidth
                  id="order"
                  error={""}
                  name="description"
                  value={description}
                  multiline
                  rows={4}
                  onChange={(e, val) => setDescription(val)}
                  autoComplete="order"
                />

              </Box>
            </Box>




          </Grid>

          <Box sx={style.itemSection}>
            <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
            <Typography sx={style.gridText}>Total Information</Typography>
          </Box>



          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Subtotal</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="subtotal"
                  error={""}
                  name="subtotal"
                  value={subtotal}
                  onChange={(e, val) => setsubTotal(val)}
                  autoComplete="order"
                />

              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Tax</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="tax"
                  error={""}
                  name="tax"
                  value={tax}
                  onChange={(e, val) => setTax(val)}
                  autoComplete="order"
                />

              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Grand Total</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="order"
                  error={""}
                  name="grandTotal"
                  value={grandTotal}
                  onChange={(e, val) => setGrandTotal(val)}
                  autoComplete="order"
                />

              </Box>              

            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Currency</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="order"
                  error={""}
                  name="currency"
                  value={currency}
                  onChange={(e, val) => setCurrency(val)}
                  autoComplete="order"
                />

              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Exchange Rate</Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="order"
                  error={""}
                  name="salesOrder"
                  value={exchangeRate}
                  onChange={(e, val) => setExchangeRate(val)}
                  autoComplete="order"
                />

              </Box>
              <Box sx={style.inputBox}>
              </Box>
            </Box>




          </Grid>
          <Box sx={style.itemSection}>
            <Box sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}></Box>
            <Typography sx={style.gridText}>Product Informations (optional)</Typography>
          </Box>

          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {product.map((item, index) => ( 
              <Box sx={style.leaveSection} key={index}>
                <Grid container sx={style.itemGrid} >
                  <Grid item xs={1} lg={0.5}>
                    <Typography> {index + 1}</Typography>
                  </Grid>
                  <Grid item xs={12} lg={2}>
                    <Autocomplete
                      id="autocomplete"
                      options={itemList || []}
                      getOptionLabel={(option) => option?.title}
                      onInputChange={(event, newInputValue) => {
                        handleItemList(newInputValue);
                      }}

                      onChange={(event, newValue) => {
                        handleProduct(newValue?.title, index, "name",)
                      }}

                      renderInput={(params) => (
                        <><TextField
                          placeholder="product"
                          {...params}
                          sx={{ ...style.modalInput, ...style.inputSpace }}

                          // label="Search Employee"
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }} /></>
                      )}
                    />
                    {/* <Select
                      value={product[index]?.name}
                      onChange={(e) => handleProduct(e.target.value, index, "name",)}
                      name="productName"
                      // label="Product"
                      sx={{ ...style.dropdown, marginTop: 0 }}
                      onFocus={handleFocus}
                      error={productName.error}
                    >
                      {itemList && itemList.map((item, index) => (
                        <MenuItem key={index} sx={style.dropDownMenu} data-id={item._id} value={item?.title}>{item?.title}</MenuItem>
                      ))}

                    </Select> */}
                  </Grid>
                  <Grid item xs={12} lg={3.5}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="description"
                      placeholder="Description"
                      error={""}
                      name="desc"
                      value={product[index]?.desc}
                      onChange={(e, val) => handleProduct(val, index, "desc")}
                      // onFocus={handleFocus}
                      autoComplete="desc"
                    />

                  </Grid>
                  <Grid item xs={12} lg={1.5}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="unitCost"
                      placeholder="Unit Cost"
                      error={""}
                      name="unitCost"
                      value={product[index]?.price}
                      onChange={(e, val) => handleProduct(val, index, "price")}
                      // onFocus={handleFocus}
                      autoComplete="unitCost"
                    />

                  </Grid>
                  <Grid item xs={12} lg={1}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="qty"
                      placeholder="QTY"
                      error={""}
                      name="qty"
                      value={product[index]?.quantity}
                      onChange={(e, val) => handleProduct(val, index, "quantity")}
                      // onFocus={handleFocus}
                      autoComplete="qty"
                    />

                  </Grid>
                  <Grid item xs={9} lg={1.5}>
                    <Typography sx={style.amount}>{product[index]?.amount ? product[index]?.amount.toFixed(2) : "amount"}</Typography>


                  </Grid>
                  {index === 0 && ( 
                    <Grid item xs={1.5} lg={0.5}>
                      <Box sx={style.addIcon} onClick={handleAddField}>+</Box>
                    </Grid>
                  )} 

                  {index !== 0 && ( 
                    <Grid item xs={1.5} lg={0.5}>
                      <Box sx={style.deleteIcon} onClick={() => handleDeleteField(index)}>
                        <DeleteOutlineIcon />
                      </Box>
                    </Grid>
                  )} 

                </Grid>



              </Box>

            ))} 


          </Grid>





        </Grid>

        <Box sx={style.mainBoxes}>
          <Box sx={style.createJob}>
            <Button variant="contained" type="submit" color="success" sx={style.cancelButtons} >
              Cancel
            </Button>
          </Box>
          <Box sx={style.createJob}>
            <Button variant="contained" type="submit" color="success" sx={style.jobButtons} >
              Save
            </Button>
          </Box>


        </Box>

      </form>


    </>
  )
}
export default NewSalesOrder;
